import React from 'react';
import { cn } from '@/lib/utils';
import { getAvailablePricingTypes, PricingType } from '../utils/pricingUtils';
import { PricingConfig } from '../types';

interface PricingTypeSelectorProps {
  optionType: string;
  isCore: boolean;
  selectedType: string;
  onTypeChange: (type: string) => void;
  className?: string;
}

export function PricingTypeSelector({
  optionType,
  isCore,
  selectedType,
  onTypeChange,
  className
}: PricingTypeSelectorProps) {
  const availableTypes = getAvailablePricingTypes(optionType, isCore);

  return (
    <div className={cn("space-y-3", className)}>
      <label className="text-sm font-medium text-slate-700">
        Pricing Type
      </label>
      
      <div className="grid grid-cols-1 gap-2">
        {availableTypes.map((type: PricingType) => (
          <label
            key={type.value}
            className={cn(
              "flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all hover:bg-slate-50",
              selectedType === type.value
                ? "border-emerald-500 bg-emerald-50 text-emerald-900"
                : "border-slate-200 bg-white text-slate-700"
            )}
          >
            <input
              type="radio"
              name="pricingType"
              value={type.value}
              checked={selectedType === type.value}
              onChange={(e) => onTypeChange(e.target.value)}
              className="sr-only"
            />
            
            <div className={cn(
              "w-8 h-8 rounded-lg flex items-center justify-center",
              selectedType === type.value
                ? "bg-emerald-500 text-white"
                : "bg-slate-100 text-slate-500"
            )}>
              <type.icon className="w-4 h-4" />
            </div>
            
            <div className="flex-1">
              <div className="font-medium text-sm">{type.label}</div>
              <div className="text-xs opacity-75">{type.description}</div>
            </div>
            
            <div className={cn(
              "w-4 h-4 rounded-full border-2 transition-all",
              selectedType === type.value
                ? "border-emerald-500 bg-emerald-500"
                : "border-slate-300"
            )}>
              {selectedType === type.value && (
                <div className="w-full h-full rounded-full bg-white scale-50" />
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}
